<template>
  <div class="main">
    <Login
      :defaultActiveKey="type"
      :onTabChange="onTabChange"
      :onSubmit="handleSubmit"
      v-ant-ref="
        form => {
          this.loginForm = form;
        }
      "
    >
      <Tab key="account" :tab='$t("message")["Auth.login.method.account"]'>
        <VNodes
          v-if="status === 'error' && type === 'account' && !submitting"
          :vnodes="renderMessage('account')"
        />
        <UserName
          name="userName"
          :placeholder='$t("message")["Auth.username"]+": iwown"'
          :rules='[
            {
              required: true,
              message: $t("message")["Auth.username.prompt"]
            }
          ]'
        />
        <Password
          name="password"
          :placeholder='$t("message")["Auth.password"]+": iwown2013"'
          :rules='[{ required: true, message: $t("message")["Auth.password.prompt"] }]'
          :onPressEnter="
            e => {
              e.preventDefault();
              this.form.validateFields(this.handleSubmit);
            }
          "
        />
      </Tab>
      <div>
        <a-checkbox :checked="autoLogin" @change="changeAutoLogin">
          {{ $t("message")["Auth.autologin"] }}
        </a-checkbox>
      </div>
      <Submit :loading="submitting">
        {{ $t("message")["Auth.login"] }}
      </Submit>
    </Login>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { Modal } from "ant-design-vue";
import Login from "@/components/Login";

const { Tab, UserName, Password, Mobile, Captcha, Submit } = Login;

export default {
  components: {
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes
    },
    Login,
    Tab,
    UserName,
    Password,
    Mobile,
    Captcha,
    Submit
  },
  data() {
    return {
      type: "account",
      autoLogin: true,
      submitting: false,
      count: 0,
      tabs: []
    };
  },
  computed: {
    ...mapState("login", {
      status: state => state.status
    })
  },
  methods: {
    ...mapActions("login", ["login", "getCaptcha"]),
    ...mapMutations("login", ["changeLoginStatus"]),
    handleSubmit(err, values) {
      const { type } = this.$data;
      if (!err) {
        this.submitting = true;
        this.login({
          ...values,
          type
        }).then(() => {
          this.submitting = false;
        });
      }
    },
    onTabChange(type) {
      this.type = type;
      this.changeLoginStatus({
        status: false,
        currentAuthority: "guest"
      });
    },
    changeAutoLogin(e) {
      this.autoLogin = e.target.checked;
    },
    onGetCaptcha() {
      return new Promise((resolve, reject) => {
        this.loginForm.validateFields(
          ["mobile"],
          { force: true },
          (err, values) => {
            if (err) {
              reject(err);
            } else {
              this.getCaptcha({ mobile: values.mobile })
                .then(resolve)
                .catch(reject);
              Modal.info({
                title:
                  "此项目为演示项目，并不会真的给您发送验证码。请切换到账户密码登录界面按提示登录。"
              });
            }
          }
        );
      });
    },
    renderMessage(type) {
      return (
        <a-alert
          style="margin-bottom: 24px"
          message={
            type === "account"
              ? "账户或密码错误"
              : "验证码错误"
          }
          type="error"
          showIcon
        />
      );
    }
  }
};
</script>

<style scoped lang="less">
@import "~ant-design-vue/lib/style/themes/default.less";

.main {
  width: 388px;
  margin: 0 auto;
  @media screen and (max-width: @screen-sm) {
    width: 95%;
  }

  .icon {
    margin-left: 16px;
    color: rgba(0, 0, 0, 0.2);
    font-size: 24px;
    vertical-align: middle;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: @primary-color;
    }
  }

  .other {
    margin-top: 24px;
    line-height: 22px;
    text-align: left;

    .register {
      float: right;
    }
  }
  .login {
    /deep/ .ant-tabs .ant-tabs-bar {
      margin-bottom: 24px;
      text-align: center;
      border-bottom: 0;
    }

    /deep/ .ant-form-item {
      margin: 0 2px 24px;
    }

    .getCaptcha {
      display: block;
      width: 100%;
    }

    .icon {
      margin-left: 16px;
      color: rgba(255, 255, 255, 0.2);
      font-size: 24px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: @primary-color;
      }
    }

    .other {
      margin-top: 24px;
      line-height: 22px;
      text-align: left;

      .register {
        float: right;
      }
    }

    .prefixIcon {
      color: @disabled-color;
      font-size: @font-size-base;
    }

    .submit {
      width: 100%;
      margin-top: 24px;
    }
  }
}
</style>
